import React from 'react';
import {TextField} from "@mui/material";

export default  function InputAS2Id(props) {
    return (
        <>
            <TextField
                size="small"
                inputProps={{maxLength: 255}}
                {...props}
            />
            </>
    )
}
